/**
 * Video analytics glue — thin wrapper over the fixed marketing event set.
 *
 * Events are anonymous names only (see `src/lib/track.ts`): the video group is
 * part of the name, nothing else is ever attached. `track()` is already a
 * no-op off-production and without a loaded provider, so playback never
 * depends on analytics and no consent-gated tracking can fire.
 */
import { track, type VideoEventGroup, type VideoEventVerb } from "@/lib/track";

export function trackVideo(group: VideoEventGroup, verb: VideoEventVerb): void {
  track(`video_${group}_${verb}`);
}
